export default {
    name: 'NewBusinessGSTEligibility',
    props: {
        title: String,
        instruction: String
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            showABNInput: (this.$store.state.sessionDetails.properties.registered_for_gst) ? true : false,
            is_gst_registered: (this.$store.state.sessionDetails.properties.registered_for_gst) ? true : false,
            abn_number: (this.$store.state.sessionDetails.properties.abn !== null) ? this.$store.state.sessionDetails.properties.abn : '',
            activeABNInput: 'text-lg-center response-status is_active',
            inactiveABNInput: 'text-lg-center response-status',
            dictionary: {
                attributes: {
                    abn_number: 'ABN Number',
                }
            }
        }
    },
    methods: {
        checkStoreData() {
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        backToPrevious() {

            if(this.$store.state.NewBusinessHasValidNSWAddressAndAssignedToRisk) { //jump to 2nd next routes
                this.$store.commit('mutate', {
                    property: "NewBusinessStep",
                    value: this.$store.state.NewBusinessStep - 1
                });
            } else {
                this.$store.commit('mutate', {
                    property: "NewBusinessStep",
                    value: this.$store.state.NewBusinessStep - 2
                });
            } 

        },
        initApp() {
            this.checkStoreData();
        },
        registeredGST(response) {

            if(response) {
                this.showABNInput = true;
                this.is_gst_registered = true;
            } else {
                this.showABNInput = false 
                this.is_gst_registered = false;
            }
            
        },
        async verifyABN() {
            let is_valid = await this.$validator.validateAll();
            if(is_valid) {
                window.open("https://abr.business.gov.au/ABN/View?abn=" + this.abn_number, "_blank");
            }
        },
        async submitForm() {
            let is_valid = await this.$validator.validateAll();
            if(is_valid) {


                this.$store.commit('mutate', {
                    property: "sessionDetails.properties.abn",
                    value: this.abn_number
                });

                this.$store.commit('mutate', {
                    property: "sessionDetails.properties.registered_for_gst",
                    value: this.is_gst_registered
                });
                
                // this.$store.commit('mutate', {
                //     property: "NewBusinessStep",
                //     value: this.$store.state.NewBusinessStep + 1
                // });
                this.$emit("createUpdateSession");

            }
        }
    },
    mounted() {
        this.initApp();
        this.$validator.localize('en', this.dictionary);
    }
}